// libraries
import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

class Icon extends React.Component {
  static propTypes = {
    iconType: PropTypes.string.isRequired,
    'aria-hidden': PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    rotate: PropTypes.number,
    style: PropTypes.object,
    buttonName: PropTypes.string,
    role: PropTypes.string,
    'aria-label': PropTypes.string
  };

  // NOTE: Icons are hidden from screen readers by default
  static defaultProps = {
    'aria-hidden': 'true',
    className: '',
    style: {},
  };

  getClassName() {
    return classnames(
      'icon',
      'rm',
      `rm-${this.props.iconType}`,
      this.props.className,
      {[`rm-rotate-${this.props.rotate}`]: this.props.rotate}
    );
  }

  render() {
    return (
      <i
        className={this.getClassName()}
        role={this.props.role}
        aria-hidden={this.props['aria-hidden']}
        aria-label={this.props['aria-label']}
        style={this.props.style}
        onClick={this.props.onClick}
        data-segment-track={this.props.buttonName && 'button'}
        data-button-name={this.props.buttonName}
      />
    );
  }
}

export default Icon;
